import { calcRentPresentValue } from "web_myplann/Goals/Helpers/calcRentPresentValue";
import { getRentTotal } from "web_myplann/Goals/Helpers/getRentTotal";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import { RETIREMENT_DRAWDOWN_YEARS } from "web_myplann/Inspiration/Retirement/constants";
import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";

type Params = {
	desiredIncome: number;
	gap: number;
	bridgeYears: number;
	mode: RentDrawdownMode;
};

export const getRetirementTargetCapital = ({
	desiredIncome,
	gap,
	bridgeYears,
	mode,
}: Params): number => {
	const gapCapital = getRentTotal({
		monthly: gap,
		drawdownMode: mode,
		rentYears: RETIREMENT_DRAWDOWN_YEARS,
	});
	const bridgePaidYears =
		mode === RentDrawdownMode.Perpetual
			? bridgeYears
			: Math.min(RETIREMENT_DRAWDOWN_YEARS, bridgeYears);

	return Math.round(
		gapCapital +
			calcRentPresentValue(
				desiredIncome - gap,
				bridgePaidYears * MONTHS_IN_YEAR,
			),
	);
};
